import React, {Component} from 'react';
import 'react-dom';
// import { Card } from '@material-ui/core';
import {Card, CardHeader, Row, Col, CardBody} from 'reactstrap';
import {Dropdown, Button, Button as SementicBtn} from "semantic-ui-react";
import {MDBDataTable} from "mdbreact";
import {connect} from "react-redux";
import './Style.scss';

import * as actionCreator from "../../../store/Action";
import apiConfig from "../../../axios/axios_api_services";
import axios_eventtag from "../../../axios/axios_eventtag";
import * as common from "../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import QRCode from 'qrcode';
import {Icon, Spin} from "antd";
import * as commonFunc from "../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import Download from "../../../components/Button/DownloadbleButton/index";
import * as timeutils from "../../../util/TimeConvertor";

class index extends Component {
  state = {
    search_participant: '',
    isScanQR: false,
    eventHasSubevent: true,
    event_list: [],
    eventSubEvents: [],
    startDate: "",
    endDate: "",
    subEventParticipant: [],
    eventId: '',
    subEventId: '',
    uuid:'',
    image: '',
    isSpinQRGen: false,
    cop_id: '',
    s_time: "",
    e_time: ""
  };

  getEvents = (status) => {

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(async response => {
        this.props.spinnerHandler(false);

        if (response.data.success) {
          this.setState({
            event_list: response.data.eventList,
            cop_id: corperateId
          });

          if(status === "ON_LOAD"){
            let firstEventId = response.data.eventList.length !== 0 ? response.data.eventList[0].event_id : '';
            this.setState({
              eventId: firstEventId
            });
            this.getSubEvents(firstEventId,"ON_LOAD")
          }
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getEvents(status);
        } else {
          this.props.spinnerHandler(false)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  onChangeEventHandler = (e, {value}) => {
    let id = value;
    this.setState({
      eventId: id,subEventId:'', image: '', subEventParticipant: [],uuid:''
    });
    this.getSubEvents(id);
  };
  onChangeSubeEventHandler = (e, {value}) => {
    let selectedObj = this.state.eventSubEvents.find(event => event.sub_event_id === value);
    this.setState({
      subEventId: value, image: "", uuid:selectedObj.qr_code, s_time: selectedObj.start_time, e_time: selectedObj.end_time
    });

    this.getApprovedParticipantsOnSubevent(value);
  };
  getSubEvents = (eventid,status) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.GET_SUBEVENT({event_id: eventid,  corporateId: corperateId}), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {

          this.setState({eventSubEvents: response.data.subEventList});
          if(status === "ON_LOAD"){
            let firstSubeventId = response.data.subEventList.length !== 0 ? response.data.subEventList[0].sub_event_id : '';
            this.setState({
              subEventId: firstSubeventId
            });
            this.getApprovedParticipantsOnSubevent(firstSubeventId);
          }
        } else {
          this.setState({
            eventSubEvents: []
          })
        }
      })
      .catch(async error => {
        this.props.spinnerHandler(false);
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubEvents(eventid,status);
        }
      })
      .finally(fin => {
      });
  };
  getApprovedParticipantsOnSubevent = (value) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.patch(apiConfig.GET_ALL_UNCHECKED_PARTICIPANTS({sub_event_id: value ,corporateId:corperateId}),{}, {headers: headers})
      .then(response => {
        this.generateQR();
        if (response.data.success) {
          this.setState({
            subEventParticipant: response.data.content
          });
        } else {
          this.setState({
            subEventParticipant: []
          });
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getApprovedParticipantsOnSubevent(value);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  generateQR = () => {
    this.setState({isSpinQRGen: true});
    if(this.state.uuid && this.state.uuid !== ""){
      QRCode.toDataURL(this.state.uuid.toString(),{ scale: 10 })
        .then(url => {
          this.setState({isSpinQRGen: false, image: url});
        })
        .catch(err => {
          console.error(err)
        })
    }
  };
  onCheckinHandler = (value) => {
    const body = {
      "participant_id": value.participant_id,
      "attandance": true
    };
    let mobile = value.mobile;

    swal({
      title: `Do you wish to check-in this participant? ${mobile ? `${mobile}` :``}`,
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":

          this.props.spinnerHandler(true);
          const headers = {
            "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
          };
          let corperateId = this.props.usr_obj.corporates[0].corporateId;
          axios_eventtag.patch(apiConfig.CHECKIN_PARTICIPANTS({corporateId: corperateId}), body, {headers: headers})
            .then(response => {
              this.props.spinnerHandler(false);
              common.notifyMessage(response.data.message, response.data.success ? 2 : 0);

              if (response.data.success) {
                this.getApprovedParticipantsOnSubevent(this.state.subEventId)
              }
            })
            .catch(async error => {
              let result = await common.checkErrorResponse(error);
              if (result === 1) {
                this.onCheckinHandler(value);
              }else{
                this.props.spinnerHandler(false);
              }
            })
            .finally(fin => {
            });
          break;
        default:
          break;
      }
    })
  };

  viewQRCode = (b64Code) => {
    let result = commonFunc.getB64ToBlob(b64Code);
    window.open(result, '_blank');
  };

  componentDidMount() {
    this.getEvents("ON_LOAD_");
  }

  render() {
    let {eventId,subEventId} = this.state;

    let EventList = [];

    if (this.state.event_list.length !== 0) {
      this.state.event_list.map((value, index) => {
        EventList.push({
          text: value.event_name,
          value: value.event_id,
          key: value.event_id
        })
      })
    }

    let tblColumns = this.props.table_data.columns;
    let tblRows = [];

    let subEventList = [];
    if (this.state.eventSubEvents.length !== 0) {
      this.state.eventSubEvents.map((value, index) => {
        subEventList.push({
          text: value.name,
          value: value.sub_event_id,
          key: value.sub_event_id
        });
      });
    }

    let download_option = [];
    if (this.state.subEventParticipant && this.state.subEventParticipant.length !== 0) {
      this.state.subEventParticipant.map((value, index) => {

        let event_start = new Date(timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(this.state.s_time));
        event_start.setMinutes( event_start.getMinutes() - 30 );
        let date_valid = !(event_start<=new Date() && new Date(timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(this.state.e_time))>=new Date());

        tblRows.push({
          FirstName: value.first_name,
          LastName: value.last_name,
          Phone: value.mobile,
          Email: value.email,
          Action: <div><Button
            // disabled={ date_valid }
            style={ { backgroundColor: '#53bd52', color: "white" } }
            onClick={ () => this.onCheckinHandler(value) }
          >Checkin</Button></div>
        })
        download_option.push({
          ["First Name"]: value.first_name,
          ["LastName"]: value.last_name,
          Phone: value.mobile,
          Email: value.email,
        })
      })
    }

    return (
      <div className="event-org-dashboard">
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            {
              this.props.usr_obj.userRoles === "CORP_EVENT_ORGANIZER" ?
                <h4 className={"route-name-style"}>{this.props.route_name}</h4>
                : <h4 className={"route-none-style"} />
            }
            {/*<div className="heading">*/}
              {/*<h4>Event CheckIn</h4>*/}
            {/*</div>*/}
            <Card className="card1">
              <CardHeader>
                Filter Events
              </CardHeader>
              <Col lg={12}>
                <Row className={"search-event-row"}>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Event'
                      fluid
                      search
                      selection
                      value={this.state.eventId}
                      options={EventList}
                      onChange={this.onChangeEventHandler}
                    />
                  </Col>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    {this.state.eventHasSubevent ?
                      <Dropdown
                        placeholder='Select Sub Event'
                        fluid
                        search
                        selection
                        value={this.state.subEventId}
                        options={subEventList}
                        onChange={this.onChangeSubeEventHandler}
                      /> : null}
                  </Col>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    {/* <QRCode/> */}
                    {
                      this.state.image !== "" ?
                        <Spin spinning={this.state.isSpinQRGen} delay={10}
                              indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                          {!this.state.isSpinQRGen && <div className={"view-qr-btn-wrapper"}>
                            <a className={"view-qr-btn"} onClick={() => this.viewQRCode(this.state.image)}>View QR
                              Code</a>
                            <a className={"view-qr-btn"} target={"_blank"} href={this.state.image} download={true}>Download
                              QR Code</a>
                          </div>}

                          <img src={this.state.image} style={{border: "5px solid rgba(255, 0, 0, 0.5)"}}
                               className="image-qr"/>
                        </Spin> : null
                    }
                  </Col>
                </Row>
              </Col>
            </Card>

            <Card>
              <CardHeader>
                Participants
                {this.state.subEventId ? <div className={`${download_option.length > 0 ? `refresh-cus-btn`:`refresh-cus-btn-wo-margin`}`}>
                  <SementicBtn onClick={e => this.getApprovedParticipantsOnSubevent(this.state.subEventId)} circular icon='refresh' />
                </div>:null}
                <Download data={download_option} filename={"uncheckedParticipants.csv"}/>

              </CardHeader>
              <CardBody>
                {/*{this.state.subEventParticipant.length !== 0 ?*/}
                  <MDBDataTable
                    striped
                    searching={true}
                    displayEntries={true}
                    paging={true}
                    entries={8}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    bordered
                    hover
                    data={{rows: tblRows, columns:tblColumns}}
                  />
                {/*:*/}
                  {/*<div className={"align-center fully-width"}>*/}
                    {/*<Empty description={eventId === "" ? "Please select Main Event & Sub Event" : subEventId === "" ? "Please select Sub Event" :"No Participants"} className={"empty-icon"}/>*/}
                  {/*</div>}*/}

              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  test_alleventobject: state.eventReducer.allEventsObj,
  usr_obj: state.userReducer.user,
  table_data: state.participantReducer.Event_Participant_Table_data
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
